module.exports = __webpack_public_path__ + "img/piano.jpg.6551b8fc.webp";